/**
 * Enum for Album Types
 */
const AlbumTypeEnum = {
    // Album with photos
    PHOTO: 0,
    // Album with video
    VIDEO: 1
};

export default AlbumTypeEnum;
